import DateTime from '@dealroadshow/uikit-date-time';
import type { ITimeZone } from '@dealroadshow/uikit-date-time';
import { MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import { IAskAiPromptsVersion } from '@/creditflowresearch/domain/vo/AskAiPrompts';

export const formatVersionDate = (createdAt: string, timeZone: ITimeZone): string => {
  try {
    return new DateTime(createdAt, { timeZone }).format(MONTH_DAY_YEAR_FORMAT);
  } catch {
    return '';
  }
};

export const formatVersionLabel = ({ version, createdAt }: IAskAiPromptsVersion, timeZone: ITimeZone): string => {
  const date = formatVersionDate(createdAt, timeZone);

  return date ? `v${ version } — ${ date }` : `v${ version }`;
};
